import { Text } from "components/atoms/text/Text";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import * as s from "../EmailStyled";
import { Email } from "api/interfaces/emailInterface.interface";

interface Props {
  onModal: (type?: string) => void;
  selectedEmail: Email;
}
export function ViewModal(props: Props): JSX.Element {
  const { selectedEmail } = props;

  return (
    <BigPopupTemplate title="Read Email" onModal={props.onModal}>
      <s.ViewSubWrapper>
        <s.ViewSubTitle className="subject">
          <strong>Subject:</strong> {selectedEmail.subject}
        </s.ViewSubTitle>
        <s.ViewSubTitle>
          <strong>From:</strong> DW Admin
        </s.ViewSubTitle>
        <s.ViewSubTitle>
          <strong>To:</strong>{" "}
          <span className="to">
            {selectedEmail.recipientType === "USER"
              ? selectedEmail.users.map((user, idx) => (
                  <span key={idx}>
                    {user.name}
                    {idx < selectedEmail.users.length - 1 ? "," : ""}
                  </span>
                ))
              : selectedEmail.recipientType}
          </span>
        </s.ViewSubTitle>
        <s.ViewSubTitle className="message">
          <p dangerouslySetInnerHTML={{ __html: selectedEmail.message }}></p>
        </s.ViewSubTitle>
      </s.ViewSubWrapper>
    </BigPopupTemplate>
  );
}
